var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6052 13.7005L11.8934 1.36248C10.8151 -0.452952 8.18636 -0.455364 7.10655 1.36248L0.395099 13.7005C-0.707272 15.5555 0.627367 17.9046 2.78799 17.9046H16.2118C18.3706 17.9046 19.7076 15.5574 18.6052 13.7005ZM9.5 15.678C8.88628 15.678 8.38671 15.1785 8.38671 14.5648C8.38671 13.9511 8.88628 13.4515 9.5 13.4515C10.1137 13.4515 10.6133 13.9511 10.6133 14.5648C10.6133 15.1785 10.1137 15.678 9.5 15.678ZM10.6133 11.2249C10.6133 11.8386 10.1137 12.3382 9.5 12.3382C8.88628 12.3382 8.38671 11.8386 8.38671 11.2249V5.65852C8.38671 5.0448 8.88628 4.54524 9.5 4.54524C10.1137 4.54524 10.6133 5.0448 10.6133 5.65852V11.2249Z",
    fill: "#FBBD23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchWarningIcon);
export default __webpack_public_path__ + "static/media/ach-warning-icon.24e3bf87051c7613f8f2a02ca5291bdf.svg";
export { ForwardRef as ReactComponent };